import { Component } from 'components/developer-settings';

/** @ngInject */
export default function developerSettingsRouter($stateProvider) {
    const baseState = {
        redirectTo: 'main.developer-settings.api-access',
        views: {
            content: {
                component: Component.selector
            }
        }
    };

    $stateProvider
        .state('main.developer-settings', baseState);
}



// WEBPACK FOOTER //
// ./app/components/developer-settings/developer-settings.router.js